import { data } from '../../svg/Download/data';
import { makeIcon } from '../makeIcon';

export const Download = makeIcon(data, 'download', 'Download');

export default Download;
